import { defineStore } from 'pinia';
import { Visitor } from '@/config/visitor';
import { AuthState } from '#/store';

/**
 * 实名认证状态
 */
type RealAuthStateType = {
    /**
     * 0: 未认证过，1：已提交认证信息，审核中，2：认证通过，3：认证信息被驳回
     */
    status: number;
    /**
     * 拒绝原因
     */
    reason: string;
    /**
     * 认证等级
     */
    level: string;
};

interface UserState extends AuthState {
    realAuthState: RealAuthStateType;
}

const realAuthState: RealAuthStateType = {
    status: 0,
    reason: '',
    level: '',
};

export const useUserStore = defineStore({
    id: 'app-user',
    persist: true,
    state: (): UserState => ({
        status: 0,
        token: '',
        userInfo: { ...Visitor },
        realAuthState: { ...realAuthState },
    }),
    actions: {
        setRealAuthState(data: RealAuthStateType = realAuthState) {
            this.realAuthState = { ...data };
        },
    },
});
